import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Optout from './Optout';
import UnsubscribeEmail from './UnsubscribeEmail';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/optout" element={<Optout />} />
        <Route path="/UnsubscribeEmail" element={<UnsubscribeEmail />} />
      </Routes>
    </Router>
  );
}

export default App;
